import React, { useState } from 'react';

const sortItems = ['پربازدیدترین', 'ارزانترین', 'جدیدترین'];

function SortingTitle() {
	const [sortColor, setSortColor] = useState(0);
	const handleColor = (id) => {
		setSortColor(id);
	};

	return (
		<div className='flex items-center leading-extra-loose mb-[4.2rem] bootcamp__sort'>
			<span className='text-light-prim text-cd ml-[2.4rem] bootcamp__sort--title'>
				{' '}
				مرتب سازی براساس:
			</span>
			{sortItems.map((item, id) => (
				<span
					key={id}
					onClick={() => handleColor(id)}
					className={`${
						id === sortColor ? 'bg-purple-dark-1' : 'bg-gray-light '
					} cursor-pointer px-[1rem] py-[.6rem] text-xs text-[rgba(33, 33, 33,0.9)] ml-[1.6rem] rounded-[1.6rem] transition-colors duration-200 hover:bg-purple-dark-1`}
				>
					{item}
				</span>
			))}
		</div>
	);
}
export default SortingTitle;
